export default __webpack_public_path__ + "static/media/calendar.591ce1bf.svg";